export default __webpack_public_path__ + "static/media/cover-card-email-alerte.067d1868.svg";